import React from 'react';
import { ArrowLeftIcon } from '@heroicons/react/20/solid';
import { clearPendingWpConnect, getWpSettingsUrl, getWpSiteHost } from './wpConnect';

/** Leaves the connect flow and goes back to the plugin's settings screen. */
const BackToWordPressLink = ({ pending, className = '' }) => {
  const href = pending ? getWpSettingsUrl(pending) : '';
  if (!href) return null;
  const host = getWpSiteHost(pending);

  return (
    <a
      href={href}
      onClick={clearPendingWpConnect}
      className={`inline-flex items-center gap-1.5 text-sm font-medium text-gray-600 hover:text-gray-900 ${className}`}
    >
      <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" />
      {host ? `Wróć do WordPressa (${host})` : 'Wróć do WordPressa'}
    </a>
  );
};

export default BackToWordPressLink;
